/*** IMPORTS FROM imports-loader ***/
var define = false;

import { getColorForPercentage } from "./_utilities/get-color-for-percentage.js";
import { COLORS_WHITE_TO_BLACK } from "./_constants.js";

(function ($, window, document, undefined) {
  $(document).ready(function () {
    const $WINDOW = $(window);
    const $BODY = $('[data-js-hook="body"]');
    const $MAIN_CONTENT = $('[data-js-hook="mainContent"]');
    const $BRAND_LOGO = $('[data-js-hook="brandLogo"]');
    const $NAV_BAR = $('[data-js-hook="navBar"]');
    const $NAV_TOGGLE = $('[data-js-hook="navToggle"]');
    const $HEADER = $('[data-js-hook="header"]');
    const $MEDIA = $("img, video");

    // Only run when the main contet is off screen.
    if ($MAIN_CONTENT.data("offscreen")) {
      // Even if the main content is off screen, check to see if the body does not
      // have a black background.
      if (!$BODY.data("black-background")) {
        const LOGO_HEIGHT = $BRAND_LOGO.height();

        // The nav bar's offset from the bottom of the page
        const NAV_BAR_OFFSET =
          $WINDOW.height() - ($NAV_BAR.offset().top + LOGO_HEIGHT);

        // for (let i = 0; i <= SEGMENTS; i++) {
        var logoWaypoint = new Waypoint({
          element: $MAIN_CONTENT,
          handler: function (direction) {
            if (direction == "down") {
              $BRAND_LOGO.addClass("js--color-brand");
              $NAV_TOGGLE.addClass("js--color-brand");
            } else {
              $BRAND_LOGO.removeClass("js--color-brand");
              $NAV_TOGGLE.removeClass("js--color-brand");
            }
          },
          offset: function () {
            return $(window).outerHeight(true) - NAV_BAR_OFFSET;
          },
        });
      }
      var bannerWaypoint = new Waypoint({
        element: $MAIN_CONTENT,
        handler: function (direction) {
          if (direction == "down") {
            $HEADER.addClass("js--banner-hide");
          } else {
            $HEADER.removeClass("js--banner-hide");
          }
        },
        offset: "50%",
      });
    }

    $(window).bind("scroll", function () {
      // remove hiding class if waypoint fails
      if (window.scrollY < 100) {
        $HEADER.removeClass("js--banner-hide");
      }
    });
    // add small image fade for images as they are coming onscreen
    $MEDIA.each(function () {
      var el = $(this);
      var imageFadeWaypoint = new Waypoint.Inview({
        element: el,
        enter: function (direction) {
          el.addClass("js--media-in");
        },
        exited: function (direction) {
          if (direction == "up") {
            el.removeClass("js--media-in");
          }
        },
      });
      el.on("load", function () {
        Waypoint.refreshAll();
      });
    });

    $(window).bind("enterBreakpoint320 enterBreakpoint480", function () {
      const NAV_BAR_OFFSET = $WINDOW.height() - $NAV_BAR.offset().top;

      var navBarWaypoint = new Waypoint({
        element: $MAIN_CONTENT,
        handler: function (direction) {
          if ($HEADER.data("has-image")) {
            $NAV_BAR.toggleClass("nav-bar--transparent");
          }
        },
        offset: function () {
          return (
            $(window).outerHeight(true) - (NAV_BAR_OFFSET - $NAV_BAR.height())
          );
        },
      });
    });
  });
})(jQuery, window, document);

